import { instance } from 'api/internaltools';

export const getSuperMerchantConfig = async (merchantId) => {
  return instance.get(`/super-merchant-config/${merchantId}`);
};

export const updateSuperMerchantConfig = async (merchantId, payload) => {
  return instance.post(`/dynamic-config-sm/${merchantId}`, payload);
};

export const createSuperMerchantKYB = async (payload) => {
  return instance.post('/super-merchant/kyb', payload);
};
